import React from 'react'
import Header from '../component/Header'
import ErrorPage from '../component/ErrorPage'

const ErrorTab = () => {
  return (
    <div>
        {/* <Header/> */}
        <ErrorPage/>
    </div>
  )
}

export default ErrorTab